module.exports = __webpack_public_path__ + "static/media/mivena.e61247af.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/mivena.webp
// module id = 687
// module chunks = 0